import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DictService} from "../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {OckImportService} from "../../../shared/services/ock-import.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-vin-add',
  templateUrl: './vin-add.component.html',
  styleUrls: ['./vin-add.component.scss']
})
export class VinAddComponent implements OnInit {

  vinForm: FormGroup;
  valueControl: FormControl;
  processingRequest = false;
  formValid = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private ockImportService: OckImportService
  ) {
    this.vinForm = fb.group({
      vin: this.valueControl = this.fb.control('', [Validators.required]),
    });
  }
  ngOnInit(): void {
    this.vinForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.formValid = this.vinForm.valid);
  }


  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    this.router.navigate(['/ock/import/vin']);

  }

  sendForm(): void {
    this.processingRequest = true;
    this.ockImportService.sendVin(this.vinForm.value)
      .subscribe((response) => {
        this.snack.open('Pomyślnie dodano VIN', '', {
          duration: 2000,
        });
        this.router.navigate(['/ock/import/vin']);


        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania VIN wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.processingRequest = false;
      });
  }

}
